import React from 'react';
import RadioTabGroup from '../../../components/common/RadioTabGroup';

export type PharmacyTabValue = 'checkedIn' | 'billed';

interface PharmacyTabsProps {
  activeTab: PharmacyTabValue;
  onTabChange: (tab: PharmacyTabValue) => void;
}

const tabs: { label: string; value: PharmacyTabValue }[] = [
  { label: 'Checked In', value: 'checkedIn' },
  { label: 'Billed', value: 'billed' },
];

/**
 * PharmacyTabs renders radio-button styled tabs for Checked In and Billed categories.
 */
const PharmacyTabs: React.FC<PharmacyTabsProps> = ({ activeTab, onTabChange }) => {
  return (
    <RadioTabGroup
      value={activeTab}
      onChange={onTabChange}
      options={tabs}
    />
  );
};

export default PharmacyTabs;
